import "babel-polyfill";
import React from "react";
import { render } from "react-dom";
import { Provider } from "react-redux";
import configureStore from "./stores";
import App from "./containers/App";
import Home from "./containers/HomeContainer";
import SalesPage from "./containers/SalesPageContainer";
import BoxPayContainer from "./containers/BoxPayContainer";
import LearnMoreConfirmation from "./components/pages/LearnMoreConfirmation";
import UpgradeMembershipSuccess from "./components/payments/UpgradeMembershipSuccess";
import SiteCheckoutSuccess from "./containers/SiteCheckoutSuccessContainer";
import UpgradeMembershipError from "./components/payments/UpgradeMembershipError";
import UpdatePaymentSuccess from "./components/payments/UpdatePaymentSuccess";
import UpdatePaymentError from "./components/payments/UpdatePaymentError";
import InvalidPage from "./components/coachSalesPages/InvalidPage";
import Eula from "./components/pages/Eula";
import Terms from "./components/pages/Terms";
import UserPayment from "./containers/UserPaymentContainer";
import CoachCheckout from "./containers/CoachCheckoutContainer";
import DemoCreation from "./containers/DemoCreationContainer";
import CoachLink from "./containers/CoachLinkContainer";
import CoachSales from "./containers/CoachSalesContainer";
import UserCheckout from "./containers/UserCheckoutContainer";
import UserUpdateCard from "./containers/UserUpdateCardContainer";
import StripeConfirmation from "./containers/StripeConfirmationContainer";
import GlobalStyles from "./components/GlobalStyles";
import PaymentContainer from "./containers/PaymentContainer";
import CoachGrantAccessContainer from "./containers/CoachGrantAccessContainer";
import BuyAccessCodeContainer from "./containers/BuyAccessCodeContainer";
import Redirect from "./components/landingPages/RedirectOut";
import injectTapEventPlugin from "react-tap-event-plugin";
import { Router, Route, browserHistory, IndexRoute } from "react-router";
import { syncHistoryWithStore } from "react-router-redux";
import config from "config";
import pathToCoachOrgIds from "./domains/PathToCoachOrgId";
const mapPathToOrgId = pathToCoachOrgIds[config.dbEnv];
import ReactGA from "react-ga";
import FAQScene from "./components/pages/FAQScene";
import UserFAQs from "./components/pages/UserFAQs";
import DeleteAccount from "./components/pages/DeleteAccount";
import VerifyEmail from "./components/pages/VerifyEmail";
import Waiver from "./containers/CreatorWaiverContainer";
import ResetPassword from "./components/coachSalesPages/ResetPasword";
import RedeemVoucher from "./containers/RedeemVoucherContainer";
import CoachGiftCheckout from "./containers/CoachGiftCheckoutContainer";
import PurchaseGiftSuccess from "./components/payments/PurchaseGiftsuccess";
import ContactPage from "./components/pages/ContactPage";
import PrivacyPolicy from "./components/pages/PrivacyPolicy";//Link to iubenda privacy policy
import CustomPrivacyPolicy from "./components/privacy/PrivacyPolicy";//Custom written policy for Bodyweight Warrior

ReactGA.initialize("UA-142310824-1", {
  // debug: config.dbEnv === 'dev' ? true : false,
  debug: false,
  titleCase: false,
});

require("./sass/stylesheets/main.scss");

//configureStore calls all of the sagas logic
//(login, auth, get user's trybe, get exercise library...) and reducer setup
const store = configureStore();
const history = syncHistoryWithStore(browserHistory, store);

history.listen((location) => {
  ReactGA.set({ page: location.pathname }); // Update the user's current page
  ReactGA.pageview(location.pathname); // Record a pageview for the given page
});

injectTapEventPlugin();

render(
  <Provider store={store}>
    <Router history={history}>
      <Route component={App}>
        <Route path="/" component={Home}>
          <IndexRoute component={SalesPage} />
          <Route
            path="bodyweight_warrior"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["bodyweight_warrior"]}
            tabTitle="Bodyweight Warrior"
          />
          {/* <Route
            path="bodyweight_warrior_gift"
            component={CoachGiftCheckout}
            coachOrgId={mapPathToOrgId["bodyweight_warrior"]}
            tabTitle="Bodyweight Warrior"
          /> */}
          <Route
            path="QMqXD3L25M"
            component={DemoCreation}
            coachOrgId={mapPathToOrgId["bodyweight_warrior"]}
            tabTitle="Trybe"
          />
          <Route
            path="bodyweight_warrior_app"
            component={CoachLink}
            coachOrgId={mapPathToOrgId["bodyweight_warrior"]}
            tabTitle="Bodyweight Warrior"
          />
          <Route
            path="bodyweight_warrior_checkout"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["bodyweight_warrior"]}
            tabTitle="Bodyweight Warrior"
          />
          <Route
            path="olliefrost"
            component={CoachSales}
            coachOrgId={mapPathToOrgId["ollie_frost"]}
            navBarColor="trybe-black"
            tabTitle="Ollie Frost Movement"
          />
          <Route
            path="olliefrost_checkout"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["ollie_frost"]}
            navBarColor="trybe-black"
            tabTitle="Ollie Frost Movement"
          />
          <Route
            path="humanprogramme"
            component={CoachSales}
            coachOrgId={mapPathToOrgId["ollie_frost"]}
            navBarColor="trybe-black"
            tabTitle="Human Programme"
          />
          <Route
            path="humanprogramme_checkout"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["ollie_frost"]}
            navBarColor="trybe-black"
            tabTitle="Human Programme"
          />
          <Route
            path="minusthegym"
            component={CoachSales}
            coachOrgId={mapPathToOrgId["minusthegym"]}
            navBarColor="trybe-black"
            tabTitle="Minus the Gym"
          />
          <Route
            path="minusthegym_checkout"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["minusthegym"]}
            navBarColor="trybe-black"
            tabTitle="Minus the Gym"
          />
          <Route
            path="beserious"
            component={CoachSales}
            coachOrgId={mapPathToOrgId["luca_ernst"]}
            navBarColor="trybe-black"
            tabTitle="Be Serious Calisthenics"
          />
          <Route
            path="beserious_checkout"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["luca_ernst"]}
            navBarColor="trybe-black"
            tabTitle="Be Serious Calisthenics"
          />
          <Route
            path="desmond_scott"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["desmond_scott"]}
            tabTitle="PRIME with Desmond Scott"
          />
          <Route
            path="prime"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["desmond_scott"]}
            tabTitle="PRIME with Desmond Scott"
            extraPlan="primechallenges"
          />
          <Route
            path="prime45"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["desmond_scott"]}
            tabTitle="PRIME with Desmond Scott"
            extraPlan="prime45"
          />
          <Route
            path="primebuilt"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["desmond_scott"]}
            tabTitle="PRIME with Desmond Scott"
            extraPlan="primebuilt90"
          />
          <Route
            path="hotcross"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["desmond_scott"]}
            tabTitle="PRIME with Desmond Scott"
            extraPlan="hotcross"
          />
          <Route
            path="desmond_scott_app"
            component={CoachLink}
            coachOrgId={mapPathToOrgId["desmond_scott"]}
            tabTitle="PRIME with Desmond Scott"
          />
          <Route
            path="primetraining"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["desmond_scott"]}
            // navBarColor="trybe-black"
            tabTitle="#PRIME with Desmond Scott"
            extraPlan="primetraining"
          />
          {/* <Route
            path="primebuilt90"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["desmond_scott"]}
            // navBarColor="trybe-black"
            tabTitle="#PRIME with Desmond Scott"
            extraPlan="primebuilt90"
          /> */}
          <Route
            path="inshape_app"
            component={CoachLink}
            coachOrgId={mapPathToOrgId["hana_milly"]}
            tabTitle="InShape with Hana Milly"
          />
          <Route
            path="InShape"
            component={CoachSales}
            coachOrgId={mapPathToOrgId["hana_milly"]}
            navBarColor="trybe-black"
            tabTitle="InShape with Hana Milly"
          />
          <Route
            path="InShape_checkout"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["hana_milly"]}
            navBarColor="trybe-black"
            tabTitle="InShape with Hana Milly"
          />
          <Route
            path="carlosconcep_app"
            component={CoachLink}
            coachOrgId={mapPathToOrgId["carlos_concepcion"]}
            tabTitle="Carlos Concepcion"
          />
          <Route
            path="carlosconcep"
            component={CoachSales}
            coachOrgId={mapPathToOrgId["carlos_concepcion"]}
            navBarColor="trybe-black"
            tabTitle="Carlos Concepcion"
          />
          <Route
            path="carlosconcep_checkout"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["carlos_concepcion"]}
            navBarColor="trybe-black"
            tabTitle="Carlos Concepcion"
          />
          <Route
            path="Pilates949"
            component={CoachSales}
            coachOrgId={mapPathToOrgId["rebecca_beckler"]}
            navBarColor="trybe-black"
            tabTitle="Pilates949: Pilates & Fitness Workouts"
          />
          <Route
            path="Pilates949_checkout"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["rebecca_beckler"]}
            navBarColor="trybe-black"
            tabTitle="Pilates949: Pilates & Fitness Workouts"
          />
          <Route
            path="MovementJourney"
            component={CoachSales}
            coachOrgId={mapPathToOrgId["john_lindsey"]}
            navBarColor="trybe-black"
            tabTitle="The Movement Journey"
          />
          <Route
            path="MovementJourney_checkout"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["john_lindsey"]}
            navBarColor="trybe-black"
            tabTitle="The Movement Journey"
          />
          <Route
            path="movementflow"
            component={CoachSales}
            coachOrgId={mapPathToOrgId["slava_goloubov"]}
            navBarColor="trybe-black"
            tabTitle="The Movement Flow"
          />
          <Route
            path="movementflow_checkout"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["slava_goloubov"]}
            navBarColor="trybe-black"
            tabTitle="The Movement Flow"
          />
          <Route
            path="movementflow_checkout_fb"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["slava_goloubov"]}
            navBarColor="trybe-black"
            tabTitle="The Movement Flow"
            extraPlan="movementflowtrial"
          />
          <Route
            path="movementflow_checkout_P6HfZd"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["slava_goloubov"]}
            navBarColor="trybe-black"
            tabTitle="The Movement Flow"
            extraPlan="movementflowtrial"
          />
          <Route
            path="annadavey"
            component={CoachSales}
            coachOrgId={mapPathToOrgId["anna_davey"]}
            navBarColor="trybe-black"
            tabTitle="Fitness & Climbing"
          />
          <Route
            path="annadavey_checkout"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["anna_davey"]}
            navBarColor="trybe-black"
            tabTitle="Fitness & Climbing"
          />
          <Route
            path="levisthenics"
            component={CoachSales}
            coachOrgId={mapPathToOrgId["levi_reiling"]}
            navBarColor="trybe-black"
            tabTitle="Levisthenics"
          />
          <Route
            path="levisthenics_checkout"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["levi_reiling"]}
            navBarColor="trybe-black"
            tabTitle="Levisthenics"
          />
          <Route
            path="movementforclimbers"
            component={CoachSales}
            coachOrgId={mapPathToOrgId["siawn_ou"]}
            navBarColor="trybe-black"
            tabTitle="Movement For Climbers"
          />
          <Route
            path="movementforclimbers_checkout"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["siawn_ou"]}
            navBarColor="trybe-black"
            tabTitle="Movement For Climbers"
          />
          <Route
            path="taophysique"
            component={CoachSales}
            coachOrgId={mapPathToOrgId["tome_tao"]}
            navBarColor="trybe-black"
            tabTitle="Tao Physique"
          />
          <Route
            path="taophysique_checkout"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["tome_tao"]}
            navBarColor="trybe-black"
            tabTitle="Tao Physique"
          />
          <Route
            path="taophysique_checkout_ftoffer"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["tome_tao"]}
            navBarColor="trybe-black"
            tabTitle="Tao Physique"
            extraPlan="7daytrial"
          />
          <Route
            path="combobootcamp"
            component={CoachSales}
            coachOrgId={mapPathToOrgId["shaquille_miller"]}
            navBarColor="trybe-black"
            tabTitle="Combo Boot Camp"
          />
          <Route
            path="combobootcamp_checkout"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["shaquille_miller"]}
            navBarColor="trybe-black"
            tabTitle="Combo Boot Camp"
          />
          <Route
            path="strongnfit"
            component={CoachSales}
            coachOrgId={mapPathToOrgId["johanna_scholz"]}
            navBarColor="trybe-black"
            tabTitle="Strong'N'Fit"
          />
          <Route
            path="strongnfit_checkout"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["johanna_scholz"]}
            navBarColor="trybe-black"
            tabTitle="Strong'N'Fit"
          />
          <Route
            path="gabibutler"
            component={CoachSales}
            coachOrgId={mapPathToOrgId["gabi_butler"]}
            navBarColor="trybe-black"
            tabTitle="Gabi Butler Method"
          />
          <Route
            path="gabibutler_checkout"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["gabi_butler"]}
            navBarColor="trybe-black"
            tabTitle="Gabi Butler Method"
          />
          <Route
            path="leantone"
            component={CoachSales}
            coachOrgId={mapPathToOrgId["kelli_bettridge"]}
            navBarColor="trybe-black"
            tabTitle="Lean + Tone"
          />
          <Route
            path="leantone_checkout"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["kelli_bettridge"]}
            navBarColor="trybe-black"
            tabTitle="Lean + Tone"
          />
          <Route
            path="ochir"
            component={CoachSales}
            coachOrgId={mapPathToOrgId["ochir_ub"]}
            navBarColor="trybe-black"
            tabTitle="AcroMongolia"
          />
          <Route
            path="ochir_checkout"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["ochir_ub"]}
            navBarColor="trybe-black"
            tabTitle="AcroMongolia"
          />
          <Route
            path="levelup"
            component={CoachSales}
            coachOrgId={mapPathToOrgId["layla_luciano"]}
            navBarColor="trybe-black"
            tabTitle="Level Up! with Layla"
          />
          <Route
            path="levelup_checkout"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["layla_luciano"]}
            navBarColor="trybe-black"
            tabTitle="Level Up! with Layla"
          />
          <Route
            path="babimanu"
            component={CoachSales}
            coachOrgId={mapPathToOrgId["babi_manu"]}
            navBarColor="trybe-black"
            tabTitle="Babi Manu Wellness"
          />
          <Route
            path="babimanu_checkout"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["babi_manu"]}
            navBarColor="trybe-black"
            tabTitle="Babi Manu Wellness"
          />
          <Route
            path="elevate"
            component={CoachSales}
            coachOrgId={mapPathToOrgId["geraldo_alken"]}
            navBarColor="trybe-black"
            tabTitle="Elevate"
          />
          <Route
            path="elevate_checkout"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["geraldo_alken"]}
            navBarColor="trybe-black"
            tabTitle="Elevate"
          />
          <Route
            path="abxhud"
            component={CoachSales}
            coachOrgId={mapPathToOrgId["abbie_hudson"]}
            navBarColor="trybe-black"
            tabTitle="ELEVATE Training"
          />
          <Route
            path="abxhud_checkout"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["abbie_hudson"]}
            navBarColor="trybe-black"
            tabTitle="ELEVATE Training"
          />
          <Route
            path="asiajfit"
            component={CoachSales}
            coachOrgId={mapPathToOrgId["asia_roberson"]}
            navBarColor="trybe-black"
            tabTitle="The Lifter's Club"
          />
          <Route
            path="asiajfit_checkout"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["asia_roberson"]}
            navBarColor="trybe-black"
            tabTitle="The Lifter's Club"
          />
          <Route
            path="mobilityflow"
            component={CoachSales}
            coachOrgId={mapPathToOrgId["yuri_carvalho"]}
            navBarColor="trybe-black"
            tabTitle="Mobility Flow"
          />
          <Route
            path="mobilityflow_checkout"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["yuri_carvalho"]}
            navBarColor="trybe-black"
            tabTitle="Mobility Flow"
          />
          <Route
            path="charellberg"
            component={CoachSales}
            coachOrgId={mapPathToOrgId["charell_berg"]}
            navBarColor="trybe-black"
            tabTitle="Charell Berg"
          />
          <Route
            path="charellberg_checkout"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["charell_berg"]}
            navBarColor="trybe-black"
            tabTitle="Charell Berg"
          />
          <Route
            path="charellberg_checkout_14ftoffer"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["charell_berg"]}
            navBarColor="trybe-black"
            tabTitle="Charell Berg"
            extraPlan="14dayft"
          />
          <Route
            path="calisthenixpro"
            component={CoachSales}
            coachOrgId={mapPathToOrgId["xavier_cormier"]}
            navBarColor="trybe-black"
            tabTitle="Calisthenix Pro"
          />
          <Route
            path="calisthenixpro_checkout"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["xavier_cormier"]}
            navBarColor="trybe-black"
            tabTitle="Calisthenix Pro"
          />
          <Route
            path="svagtillstark"
            component={CoachSales}
            coachOrgId={mapPathToOrgId["amanda_essen"]}
            navBarColor="trybe-black"
            tabTitle="Svagtillstark"
          />
          <Route
            path="svagtillstark_checkout"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["amanda_essen"]}
            navBarColor="trybe-black"
            tabTitle="Svagtillstark"
          />
          <Route
            path="jaredfeather"
            component={CoachSales}
            coachOrgId={mapPathToOrgId["jared_feather"]}
            navBarColor="trybe-black"
            tabTitle="Jared Feather"
          />
          <Route
            path="jaredfeather_checkout"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["jared_feather"]}
            navBarColor="trybe-black"
            tabTitle="Jared Feather"
          />
          <Route
            path="awfitness"
            component={CoachSales}
            coachOrgId={mapPathToOrgId["whitney_jones"]}
            navBarColor="trybe-black"
            tabTitle="AW Fitness"
          />
          <Route
            path="awfitness_checkout"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["whitney_jones"]}
            navBarColor="trybe-black"
            tabTitle="AW Fitness"
          />
          <Route
            path="nunzziii"
            component={CoachSales}
            coachOrgId={mapPathToOrgId["michael_nunziata"]}
            navBarColor="trybe-black"
            tabTitle="NUNZI"
          />
          <Route
            path="nunzziii_checkout"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["michael_nunziata"]}
            navBarColor="trybe-black"
            tabTitle="NUNZI"
          />
          <Route
            path="nunzi"
            component={CoachSales}
            coachOrgId={mapPathToOrgId["michael_nunziata"]}
            navBarColor="trybe-black"
            tabTitle="NUNZI"
          />
          <Route
            path="nunzi_checkout"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["michael_nunziata"]}
            navBarColor="trybe-black"
            tabTitle="NUNZI"
          />
          <Route
            path="hilalleigh"
            component={CoachSales}
            coachOrgId={mapPathToOrgId["hilal_leigh"]}
            navBarColor="trybe-black"
            tabTitle="Hilal Leigh Pilates"
          />
          <Route
            path="hilalleigh_checkout"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["hilal_leigh"]}
            navBarColor="trybe-black"
            tabTitle="Hilal Leigh Pilates"
          />
          <Route
            path="mindsetoftheo"
            component={CoachSales}
            coachOrgId={mapPathToOrgId["theo_necker"]}
            navBarColor="trybe-black"
            tabTitle="Mindset of Theo"
          />
          <Route
            path="mindsetoftheo_checkout"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["theo_necker"]}
            navBarColor="trybe-black"
            tabTitle="Mindset of Theo"
          />
          <Route
            path="movementmastery_gift"
            component={CoachGiftCheckout}
            coachOrgId={mapPathToOrgId["theo_necker"]}
            navBarColor="trybe-black"
            tabTitle="Movement Mastery"
          />
          <Route
            path="movementmastery"
            component={CoachSales}
            coachOrgId={mapPathToOrgId["theo_necker"]}
            navBarColor="trybe-black"
            tabTitle="Movement Mastery"
          />
          <Route
            path="movementmastery_checkout"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["theo_necker"]}
            navBarColor="trybe-black"
            tabTitle="Movement Mastery"
          />
          <Route
            path="peacockpilates"
            component={CoachSales}
            coachOrgId={mapPathToOrgId["peacock_pilates"]}
            navBarColor="trybe-black"
            tabTitle="Peacock Pilates"
          />
          <Route
            path="peacockpilates_checkout"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["peacock_pilates"]}
            navBarColor="trybe-black"
            tabTitle="Peacock Pilates"
          />
          <Route
            path="maestroworkout"
            component={CoachSales}
            coachOrgId={mapPathToOrgId["maestro_workout"]}
            navBarColor="trybe-black"
            tabTitle="MaestroWorkout"
          />
          <Route
            path="maestroworkout_Bqohvw"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["maestro_workout"]}
            navBarColor="trybe-black"
            tabTitle="MaestroWorkout"
            extraPlan="maestromonthly"
          />
          <Route
            path="maestroworkout_BqChvw"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["maestro_workout"]}
            navBarColor="trybe-black"
            tabTitle="MaestroWorkout"
            extraPlan="maestro6month"
          />
          <Route
            path="maestroworkout_BqChva"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["maestro_workout"]}
            navBarColor="trybe-black"
            tabTitle="MaestroWorkout"
            extraPlan="maestroannual"
          />
          <Route
            path="maestroworkout_checkout"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["maestro_workout"]}
            navBarColor="trybe-black"
            tabTitle="MaestroWorkout"
          />
          <Route
            path="baseblocks"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["baseblocks"]}
            navBarColor="trybe-black"
            tabTitle="BaseBlocks+"
            useBrandedHeader
          />
          <Route
            path="baseblocks_qysLnJEG"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["baseblocks"]}
            navBarColor="trybe-black"
            tabTitle="BaseBlocks+"
            useBrandedHeader
            extraPlan="6weektrial"
          />
          <Route
            path="baseblocks_DvWsEdxh"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["baseblocks"]}
            navBarColor="trybe-black"
            tabTitle="BaseBlocks+"
            useBrandedHeader
            extraPlan="90daytrial"
          />
          <Route
            path="baseblocks_PGSuWqehMp"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["baseblocks"]}
            navBarColor="trybe-black"
            tabTitle="BaseBlocks+"
            useBrandedHeader
            extraPlan="30daytrial"
          />
          <Route
            path="baseblocks_bLDrvTDbXI"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["baseblocks"]}
            navBarColor="trybe-black"
            tabTitle="BaseBlocks+"
            useBrandedHeader
            extraPlan="7daytrial"
          />
          <Route
            path="leomoves"
            component={CoachSales}
            coachOrgId={mapPathToOrgId["leandro_fornito"]}
            navBarColor="trybe-black"
            tabTitle="Leo Moves"
          />
          <Route
            path="leomoves_checkout"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["leandro_fornito"]}
            navBarColor="trybe-black"
            tabTitle="Leo Moves"
          />
          <Route
            path="leomoves_gift"
            component={CoachGiftCheckout}
            coachOrgId={mapPathToOrgId["leandro_fornito"]}
            navBarColor="trybe-black"
            tabTitle="Leo Moves"
          />
          <Route
            path="bergmovement_checkout"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["sondre_berg"]}
            navBarColor="trybe-black"
            tabTitle="Berg Movement"
            enableRewardful
          />
          <Route
            path="bergmovement_gift"
            component={CoachGiftCheckout}
            coachOrgId={mapPathToOrgId["sondre_berg"]}
            navBarColor="trybe-black"
            tabTitle="Berg Movement"
            extraPlan="bergmovementgift"
          />
          <Route
            path="bergmovement_checkout_woodpower"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["sondre_berg"]}
            navBarColor="trybe-black"
            tabTitle="Berg Movement"
            extraPlan="woodpower"
            enableRewardful
          />
          <Route
            path="bergmovement_checkout_14dayft"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["sondre_berg"]}
            navBarColor="trybe-black"
            tabTitle="Berg Movement"
            extraPlan="14daytrial"
            enableRewardful
          />
          <Route
            path="double_aacademy"
            component={CoachSales}
            coachOrgId={mapPathToOrgId["double_aacademy"]}
            navBarColor="trybe-black"
            tabTitle="Double AAcademy with Ariane Andrew"
          />
          <Route
            path="double_aacademy_checkout"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["double_aacademy"]}
            navBarColor="trybe-black"
            tabTitle="Double AAcademy with Ariane Andrew"
          />
          <Route
            path="infinity"
            component={CoachSales}
            coachOrgId={mapPathToOrgId["derek_williams"]}
            navBarColor="trybe-black"
            tabTitle="Infinity Fit"
          />
          <Route
            path="infinity_checkout"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["derek_williams"]}
            navBarColor="trybe-black"
            tabTitle="Infinity Fit"
          />
          <Route
            path="brittanycates"
            component={CoachSales}
            coachOrgId={mapPathToOrgId["brittany_cates"]}
            navBarColor="trybe-black"
            tabTitle="Brittany Cates"
          />
          <Route
            path="brittanycates_checkout"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["brittany_cates"]}
            navBarColor="trybe-black"
            tabTitle="Brittany Cates"
          />
          <Route
            path="kettlebell_therapy"
            component={CoachSales}
            coachOrgId={mapPathToOrgId["kettlebell_therapy"]}
            navBarColor="trybe-black"
            tabTitle="Kettlebell Therapy"
          />
          <Route
            path="kettlebell_therapy_checkout"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["kettlebell_therapy"]}
            navBarColor="trybe-black"
            tabTitle="Kettlebell Therapy"
          />
          <Route
            path="theflexibilityguy"
            component={CoachSales}
            coachOrgId={mapPathToOrgId["theflexibilityguy"]}
            navBarColor="trybe-black"
            tabTitle="The Flexibility Guy"
          />
          <Route
            path="theflexibilityguy_checkout"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["theflexibilityguy"]}
            navBarColor="trybe-black"
            tabTitle="The Flexibility Guy"
          />
          <Route
            path="zackheight"
            component={CoachSales}
            coachOrgId={mapPathToOrgId["zackheight"]}
            navBarColor="trybe-black"
            tabTitle="Zack Height"
          />
          <Route
            path="zackheight_checkout"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["zackheight"]}
            navBarColor="trybe-black"
            tabTitle="Zack Height"
          />
          <Route
            path="striqfit"
            component={CoachSales}
            coachOrgId={mapPathToOrgId["striqfit"]}
            navBarColor="trybe-black"
            tabTitle="STRIQfit"
          />
          <Route
            path="striqfit_checkout"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["striqfit"]}
            navBarColor="trybe-black"
            tabTitle="STRIQfit"
          />
          <Route
            path="noelcomfit"
            component={CoachSales}
            coachOrgId={mapPathToOrgId["noelcomfit"]}
            navBarColor="trybe-black"
            tabTitle="NOELCOMFIT"
          />
          <Route
            path="noelcomfit_checkout"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["noelcomfit"]}
            navBarColor="trybe-black"
            tabTitle="NOELCOMFIT"
          />
          <Route
            path="movementcollective"
            component={CoachSales}
            coachOrgId={mapPathToOrgId["movement_collective"]}
            navBarColor="trybe-black"
            tabTitle="Movement Collective"
          />
          <Route
            path="movementcollective_checkout"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["movement_collective"]}
            navBarColor="trybe-black"
            tabTitle="Movement Collective"
          />
          <Route
            path="ftelevate"
            component={CoachSales}
            coachOrgId={mapPathToOrgId["ftelevate"]}
            navBarColor="trybe-black"
            tabTitle="FTELEVATE"
          />
          <Route
            path="ftelevate_checkout"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["ftelevate"]}
            navBarColor="trybe-black"
            tabTitle="FTELEVATE"
          />
          <Route
            path="paultwyman"
            component={CoachSales}
            coachOrgId={mapPathToOrgId["paultwyman"]}
            navBarColor="trybe-black"
            tabTitle="Paul Twyman"
          />
          <Route
            path="paultwyman_checkout"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["paultwyman"]}
            navBarColor="trybe-black"
            tabTitle="Paul Twyman"
          />
          <Route
            path="andrystrong"
            component={CoachSales}
            coachOrgId={mapPathToOrgId["andrystrong"]}
            navBarColor="trybe-black"
            tabTitle="Andry Strong Academy"
          />
          <Route
            path="andrystrong_checkout"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["andrystrong"]}
            navBarColor="trybe-black"
            tabTitle="Andry Strong Academy"
          />
          <Route
            path="feetup"
            component={CoachSales}
            coachOrgId={mapPathToOrgId["feetup"]}
            navBarColor="trybe-black"
            tabTitle="FeetUp"
          />
          <Route
            path="feetup_checkout"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["feetup"]}
            navBarColor="trybe-black"
            tabTitle="FeetUp"
          />
          <Route
            path="calistrength"
            component={CoachSales}
            coachOrgId={mapPathToOrgId["nadine_hettinga"]}
            navBarColor="trybe-black"
            tabTitle="Cali Strength"
          />
          <Route
            path="calistrength_checkout"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["nadine_hettinga"]}
            navBarColor="trybe-black"
            tabTitle="Cali Strength"
          />
          <Route
            path="paradigmofperfection_gift"
            component={CoachGiftCheckout}
            coachOrgId={mapPathToOrgId["laura_kummerle"]}
            navBarColor="trybe-black"
            tabTitle="Paradigm of Perfection"
          />
          <Route
            path="paradigmofperfection"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["laura_kummerle"]}
            navBarColor="trybe-black"
            tabTitle="Paradigm of Perfection"
          />
          <Route
            path="tbgapp"
            component={CoachSales}
            coachOrgId={mapPathToOrgId["woo_sah"]}
            navBarColor="trybe-black"
            tabTitle="Woo.Sah"
          />
          <Route
            path="tbgapp_checkout"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["woo_sah"]}
            navBarColor="trybe-black"
            tabTitle="Woo.Sah"
          />
          <Route
            path="omarfit"
            component={CoachSales}
            coachOrgId={mapPathToOrgId["omarfit"]}
            navBarColor="trybe-black"
            tabTitle="Omar Fit"
          />
          <Route
            path="omarfit_checkout"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["omarfit"]}
            navBarColor="trybe-black"
            tabTitle="Omar Fit"
          />
          <Route
            path="embracemovement"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["embracemovement"]}
            navBarColor="trybe-black"
            tabTitle="Embrace Movement"
          />
          <Route
            path="kickassyoga"
            component={CoachSales}
            coachOrgId={mapPathToOrgId["kickassyoga"]}
            navBarColor="trybe-black"
            tabTitle="KickAssYoga"
          />
          <Route
            path="kickassyoga_checkout"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["kickassyoga"]}
            navBarColor="trybe-black"
            tabTitle="KickAssYoga"
          />
          <Route
            path="bootygains"
            component={CoachSales}
            coachOrgId={mapPathToOrgId["cheyenne_gonzalez"]}
            navBarColor="trybe-black"
            tabTitle="BootyGains"
          />
          <Route
            path="bootygains_checkout"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["cheyenne_gonzalez"]}
            navBarColor="trybe-black"
            tabTitle="BootyGains"
          />
          <Route
            path="trickvault"
            component={CoachSales}
            coachOrgId={mapPathToOrgId["trickvault"]}
            navBarColor="trybe-black"
            tabTitle="Trick Vault"
          />
          <Route
            path="trickvault_checkout"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["trickvault"]}
            navBarColor="trybe-black"
            tabTitle="Trick Vault"
          />
          <Route
            path="christiancruzfitness"
            component={CoachSales}
            coachOrgId={mapPathToOrgId["christiancruz"]}
            navBarColor="trybe-black"
            tabTitle="Christian Cruz"
          />
          <Route
            path="christiancruzfitness_checkout"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["christiancruz"]}
            navBarColor="trybe-black"
            tabTitle="Christian Cruz"
          />
          <Route
            path="arfit"
            component={CoachSales}
            coachOrgId={mapPathToOrgId["arielrodriguez"]}
            navBarColor="trybe-black"
            tabTitle="Ariel Rodriguez"
          />
          <Route
            path="arfit_checkout"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["arielrodriguez"]}
            navBarColor="trybe-black"
            tabTitle="Ariel Rodriguez"
          />
          <Route
            path="alexandrosthenics"
            component={CoachSales}
            coachOrgId={mapPathToOrgId["alexandrosthenics"]}
            navBarColor="trybe-black"
            tabTitle="Alexandrosthenics"
          />
          <Route
            path="alexandrosthenics_checkout"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["alexandrosthenics"]}
            navBarColor="trybe-black"
            tabTitle="Alexandrosthenics"
          />
          <Route
            path="movewithnevin"
            component={CoachSales}
            coachOrgId={mapPathToOrgId["movewithnevin"]}
            navBarColor="trybe-black"
            tabTitle="Move with Nevin"
          />
          <Route
            path="movewithnevin_checkout"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["movewithnevin"]}
            navBarColor="trybe-black"
            tabTitle="Move with Nevin"
          />
          <Route
            path="brennanmejia"
            component={CoachSales}
            coachOrgId={mapPathToOrgId["brennanmejia"]}
            navBarColor="trybe-black"
            tabTitle="Brennan Mejia"
          />
          <Route
            path="brennanmejia_checkout"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["brennanmejia"]}
            navBarColor="trybe-black"
            tabTitle="Brennan Mejia"
          />
          <Route
            path="calitokyo"
            component={CoachSales}
            coachOrgId={mapPathToOrgId["calitokyo"]}
            navBarColor="trybe-black"
            tabTitle="Calisthenics Tokyo"
          />
          <Route
            path="calitokyo_checkout"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["calitokyo"]}
            navBarColor="trybe-black"
            tabTitle="Calisthenics Tokyo"
          />
          <Route
            path="jeffskamalo"
            component={CoachSales}
            coachOrgId={mapPathToOrgId["jeffskamalo"]}
            navBarColor="trybe-black"
            tabTitle="Jeffskamalo"
          />
          <Route
            path="jeffskamalo_checkout"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["jeffskamalo"]}
            navBarColor="trybe-black"
            tabTitle="Jeffskamalo"
          />
          <Route
            path="aleksandrbatuev"
            component={CoachSales}
            coachOrgId={mapPathToOrgId["aleksandrbatuev"]}
            navBarColor="trybe-black"
            tabTitle="Contortion"
          />
          <Route
            path="aleksandrbatuev_checkout"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["aleksandrbatuev"]}
            navBarColor="trybe-black"
            tabTitle="Contortion"
          />
          <Route
            path="chrisharriz"
            component={CoachSales}
            coachOrgId={mapPathToOrgId["chrisharriz"]}
            navBarColor="trybe-black"
            tabTitle="Chris Harris"
          />
          <Route
            path="chrisharriz_checkout"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["chrisharriz"]}
            navBarColor="trybe-black"
            tabTitle="Chris Harris"
          />
          <Route
            path="calisthenicsbypaulina"
            component={CoachSales}
            coachOrgId={mapPathToOrgId["paulinaroquett"]}
            navBarColor="trybe-black"
            tabTitle="Calisthenics by Paulina"
          />
          <Route
            path="calisthenicsbypaulina_checkout"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["paulinaroquett"]}
            navBarColor="trybe-black"
            tabTitle="Calisthenics by Paulina"
          />
          <Route
            path="drglutes"
            component={CoachSales}
            coachOrgId={mapPathToOrgId["simondingemans"]}
            navBarColor="trybe-black"
            tabTitle="Simon Dingemans"
          />
          <Route
            path="drglutes_checkout"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["simondingemans"]}
            navBarColor="trybe-black"
            tabTitle="Simon Dingemans"
          />
          <Route
            path="aniamoves"
            component={CoachSales}
            coachOrgId={mapPathToOrgId["aniamoves"]}
            navBarColor="trybe-black"
            tabTitle="Aniamoves"
          />
          <Route
            path="aniamoves_checkout"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["aniamoves"]}
            navBarColor="trybe-black"
            tabTitle="Aniamoves"
          />
          <Route
            path="shapeshiftguide"
            component={CoachSales}
            coachOrgId={mapPathToOrgId["shapeshiftguide"]}
            navBarColor="trybe-black"
            tabTitle="Shapeshift Guide"
          />
          <Route
            path="shapeshiftguide_checkout"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["shapeshiftguide"]}
            navBarColor="trybe-black"
            tabTitle="Shapeshift Guide"
          />
          <Route
            path="athletistry"
            component={CoachSales}
            coachOrgId={mapPathToOrgId["athletistry"]}
            navBarColor="trybe-black"
            tabTitle="Athletistry Academy"
          />
          <Route
            path="athletistry_checkout"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["athletistry"]}
            navBarColor="trybe-black"
            tabTitle="Athletistry Academy"
          />
          <Route
            path="strongandmobile"
            component={CoachSales}
            coachOrgId={mapPathToOrgId["strongandmobile"]}
            navBarColor="trybe-black"
            tabTitle="Strong and Mobile - Elliot"
          />
          <Route
            path="strongandmobile_checkout"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["strongandmobile"]}
            navBarColor="trybe-black"
            tabTitle="Strong and Mobile - Elliot"
          />
          <Route
            path="lineup"
            component={CoachSales}
            coachOrgId={mapPathToOrgId["lineup"]}
            navBarColor="trybe-black"
            tabTitle="LineUp with Seline"
          />
          <Route
            path="lineup_checkout"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["lineup"]}
            navBarColor="trybe-black"
            tabTitle="LineUp with Seline"
          />
          <Route
            path="andriibondarenko"
            component={CoachSales}
            coachOrgId={mapPathToOrgId["andriibondarenko"]}
            navBarColor="trybe-black"
            tabTitle="Andrii Bondarenko"
          />
          <Route
            path="andriibondarenko_checkout"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["andriibondarenko"]}
            navBarColor="trybe-black"
            tabTitle="Andrii Bondarenko"
          />
          <Route
            path="sofyayokoyama"
            component={CoachSales}
            coachOrgId={mapPathToOrgId["sofyayokoyama"]}
            navBarColor="trybe-black"
            tabTitle="Sofya Yokoyama"
          />
          <Route
            path="sofyayokoyama_checkout"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["sofyayokoyama"]}
            navBarColor="trybe-black"
            tabTitle="Sofya Yokoyama"
          />
          <Route
            path="nathan"
            component={CoachSales}
            coachOrgId={mapPathToOrgId["nathan"]}
            navBarColor="trybe-black"
            tabTitle="Nathan Tsuji - Health & Handstands"
          />
          <Route
            path="nathan_checkout"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["nathan"]}
            navBarColor="trybe-black"
            tabTitle="Nathan Tsuji - Health & Handstands"
          />
          <Route
            path="sifunate"
            component={CoachSales}
            coachOrgId={mapPathToOrgId["sifunate"]}
            navBarColor="trybe-black"
            tabTitle="SifuNate"
          />
          <Route
            path="sifunate_checkout"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["sifunate"]}
            navBarColor="trybe-black"
            tabTitle="SifuNate"
          />
          <Route
            path="flexiblestrength"
            component={CoachSales}
            coachOrgId={mapPathToOrgId["valeriebrown"]}
            navBarColor="trybe-black"
            tabTitle="Flexible Strength"
          />
          <Route
            path="flexiblestrength_checkout"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["valeriebrown"]}
            navBarColor="trybe-black"
            tabTitle="Flexible Strength"
          />
          <Route
            path="physicalempowerment"
            component={CoachSales}
            coachOrgId={mapPathToOrgId["physicalempowerment"]}
            navBarColor="trybe-black"
            tabTitle="Physical Empowerment"
          />
          <Route
            path="physicalempowerment_checkout"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["physicalempowerment"]}
            navBarColor="trybe-black"
            tabTitle="Physical Empowerment"
          />
          <Route
            path="nalamoves"
            component={CoachCheckout}
            coachOrgId={mapPathToOrgId["nalamoves"]}
            navBarColor="trybe-black"
            tabTitle="Nalamoves"
          />
          <Route
            path="try_double_aacademy"
            component={Redirect}
            link={"https://trybe.app.link/double_aacademy"}
            tabTitle="Double AAcademy with Ariane Andrew"
          />
          <Route path="site_checkout_404" component={InvalidPage} />
          <Route path="site_checkout_success" component={SiteCheckoutSuccess} />
          <Route
            path="bodyweight_warrior_site_checkout_success"
            component={SiteCheckoutSuccess}
          />
          <Route path="user_payment" component={UserPayment} />
          <Route path="user_checkout" component={UserCheckout} />
          <Route path="user_update_card" component={UserUpdateCard} />
          <Route
            path="stripe_connected_confirmation"
            component={StripeConfirmation}
          />
          <Route
            path="upgrade_membership_success"
            component={UpgradeMembershipSuccess}
          />
          <Route
            path="upgrade_membership_error"
            component={UpgradeMembershipError}
          />
          <Route
            path="update_payment_success"
            component={UpdatePaymentSuccess}
          />
          <Route path="update_payment_error" component={UpdatePaymentError} />
          <Route path="privacy" component={PrivacyPolicy} />
          <Route path="agreement" component={Eula} />
          <Route path="faqs" component={FAQScene} />
          <Route path="UserFAQs" component={UserFAQs} />
          <Route path="waiver" component={Waiver} />
          <Route path="terms" component={Terms} />
          <Route path="box_sign_up" component={BoxPayContainer} />
          <Route path="forgotpassword" component={ResetPassword} />
          <Route path="delete_account" component={DeleteAccount} />
          <Route path="bodyweight_warrior_delete" component={DeleteAccount} coachName="Bodyweight Warrior"/>
          <Route path="verify_email" component={VerifyEmail} />
          <Route path="redeem" component={RedeemVoucher} />
          <Route path="gift_success" component={PurchaseGiftSuccess} />
          <Route
            path="bodyweight-warrior-privacy"
            component={CustomPrivacyPolicy}
            coachOrgId={mapPathToOrgId["bodyweight_warrior"]}
          />
          <Route path="contact" component={ContactPage} />
          <Route
            path="coach_grant_access"
            component={CoachGrantAccessContainer}
          />
          <Route path="dhr_coach_sign_up" component={BuyAccessCodeContainer} />
          <Route path="pay" component={PaymentContainer} />
          <Route
            path="learn_more_confirmation"
            component={LearnMoreConfirmation}
          />
        </Route>
      </Route>
    </Router>
  </Provider>,
  document.getElementById("app")
);



// WEBPACK FOOTER //
// ./src/index.js